module.exports = __webpack_public_path__ + "img/newPeopleVipUnreceive.1f65c5df.png";